export function getGTMEvent(alias: GTMEventAlias, data: Partial<GtmEvents> = {}): GtmEvents {
  switch (alias) {
    case GTMEventAlias.login:
      return { event: 'UAevent', eventCategory: 'customer-login', eventAction: 'customer-login-success', eventLabel: true }
    case GTMEventAlias.registration:
      return { event: 'UAevent', eventCategory: 'customer-registration', eventAction: 'reg-form-first-login', eventLabel: true }
    case GTMEventAlias.route:
      return { event: 'virtualPageView', ...data } as any
    case GTMEventAlias.tagIntegration:
      return { event: 'UAevent', eventCategory: 'customer-site', eventAction: 'versite-get–snippet', eventLabel: true }
    case GTMEventAlias.redirectIntegration:
      return { event: 'UAevent', eventCategory: 'customer-site', eventAction: 'versite-get-url', eventLabel: true }

  }
}

export enum GTMEventAlias {
  login,
  registration,
  route,
  tagIntegration,
  redirectIntegration
}

export type GtmEvents =
  | { event: 'virtualPageView', virtualPagePath: string }
  | { event: 'UAevent', eventCategory: 'customer-registration', eventAction: 'reg-form-first-login', eventLabel: true }
  | { event: 'UAevent', eventCategory: 'customer-login', eventAction: 'customer-login-success', eventLabel: true }
  | { event: 'UAevent', eventCategory: 'customer-site', eventAction: 'versite-get–snippet' | 'versite-get-url', eventLabel: true }
